module.exports = __webpack_public_path__ + "static/media/cactus-eco-ecology-svgrepo-com.a8416d08.svg";